<template>
  <div class="conditionsVehicles">
    <div class="chart" ref="chart"/>
  </div>
</template>

<script>
import echarts from "echarts";
import api from "@ISS/situation/api";

export default {
  name: "ConditionsVehicles",
  data() {
    return {
      chart: null
    }
  },
  mounted() {
    this.queryInfo()
  },
  methods: {
    async queryInfo() {
      const {success, returnObj} = await this.$fetch(api.dispatch.queryWaitingLoadedAndUnloaded)
      if (success) {
        this.initCharts(returnObj)
      }
    },
    initCharts(obj) {
      if (this.chart) {
        this.chart.dispose()
        this.chart = null
      }
      const listData = [
        {value: obj && obj.waitingLoadedTotal ? obj.waitingLoadedTotal : 0, name: "装货车辆"},
        {value: obj && obj.waitingUnloadedTotal ? obj.waitingUnloadedTotal : 0, name: "卸货车辆"},
        {value: obj && obj.waitingCrossTotal ? obj.waitingCrossTotal : 0, name: "过车车辆"}
      ]
      const option = {
        color: ['#93BEFF', '#FAC858', '#63ffca'],
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)",
        },
        legend: {
          orient: "vertical",
          right: "10%",
          y: 'center',
          itemWidth: 10,
          itemHeight: 10,
          data: ["装货车辆", "卸货车辆", "过车车辆"],
          textStyle: {
            color: "#fff",
            fontSize: 14,
          },
          formatter: (name) => {
            return name + ' ' + listData[listData.findIndex(v => v.name === name)].value;
          }
        },
        series: [
          {
            name: "待装卸车辆情况",
            type: "pie",
            radius: ["30%", "70%"],
            center: ["30%", "50%"],
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false,
                position: "center",
              },
              emphasis: {
                show: true,
                textStyle: {
                  color: '#fff',
                  fontSize: "16",
                  fontWeight: "bold",
                },
              },
            },
            labelLine: {
              normal: {
                show: false,
              },
            },
            data: listData,
          },
        ],
      };

      this.chart = echarts.init(this.$refs.chart);
      this.chart.setOption(option);
    }
  }
}
</script>

<style lang="scss" scoped>
.conditionsVehicles {
  height: 100%;
  width: 100%;

  .chart {
    height: 100%;
    width: 100%;
  }
}
</style>
